import React, { Component } from "react";
import withAuthorization from "../../../components/Authorization/withAuthorization";
import Stepper from "react-stepper-horizontal";
import { Button, Modal } from "react-bootstrap";
import RegisterLoginGuidebot from "../Tutorial_file/RegisterLoginGuidebot.jsx";
import { fire, auth } from "../../../firebase/index";
import LocalizedStrings from "react-localization";

let localizationStrings = new LocalizedStrings({
  en: {
    button: "Register and Login Guide",
    header: "Register and Login",
  },
  ja: {
    button: "登録とログインガイド",
    header: "新規登録・ログイン",
  },
  es: {
    button: "Guía para Registrarse e Iniciar Sesión",
    header: "Registrarse e Iniciar sesión",
  },
});

class RegisterLoginpdf extends Component {
  constructor() {
    super();
    this.state = {
      showPopup: false,
    };

    this.handlePopup = this.handlePopup.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  componentDidMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          localizationStrings.setLanguage(snapshot.val());
        });
    }
  }

  handlePopup() {
    this.setState({ showPopup: true });
  }

  handleClose() {
    this.setState({ showPopup: false });
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    const modalStyle = {
      color: "black",
    };

    const buttonStyle = {
      backgroundColor: "#FFC500",
      color: "black",
      borderRadius: "5px",
      padding: "10px 20px",
      border: "none",
      cursor: "pointer",
    };

    const containerStyle = {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      width: "100%",
    };

    const modalDialogStyle = {
      maxWidth: "80%",
      width: "80%",
    };

    const shareLockStyle = {
      width: "100%",
      height: "auto",
    };

    return (
      <div style={containerStyle}>
        <button onClick={this.handlePopup} style={buttonStyle}>
          {localizationStrings.button}
        </button>
        <Modal
          show={this.state.showPopup}
          onHide={this.handleClose}
          style={modalStyle}
          dialogClassName="modal-90w"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                {localizationStrings.header}
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div style={containerStyle}>
              <RegisterLoginGuidebot style={shareLockStyle} />
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default RegisterLoginpdf;
